module.exports = __webpack_public_path__ + "static/media/icon2.b6510e07.png";